import { useTranslation } from '@eon/i18n';
import { Badge, Button, Card, CardContent, EmptyState, PageHeader } from '@eon/ui';
import { hooks } from '@eon/api-client';
import { Bell } from 'lucide-react';
import { formatRelative } from '@eon/utils';

export function NotificationsPage() {
  const { t } = useTranslation();
  const list = hooks.useNotifications();
  const markRead = hooks.useMarkNotificationRead();

  if (list.isLoading) {
    return (
      <>
        <PageHeader title={t('nav.notifications')} />
        <Card>
          <CardContent className="text-muted-foreground p-6">{t('common.loading')}</CardContent>
        </Card>
      </>
    );
  }

  if (!list.data || list.data.data.length === 0) {
    return (
      <>
        <PageHeader title={t('nav.notifications')} />
        <EmptyState icon={Bell} title={t('notifications.empty')} />
      </>
    );
  }

  return (
    <>
      <PageHeader title={t('nav.notifications')} />
      <div className="space-y-2">
        {list.data.data.map((n) => (
          <Card key={n.id} className={n.read ? 'opacity-70' : ''}>
            <CardContent className="flex items-start justify-between gap-3 p-4">
              <div>
                <div className="flex items-center gap-2">
                  <Bell className="text-electric-500 h-4 w-4" />
                  <p className="text-sm font-medium">{n.title}</p>
                  {!n.read ? <Badge variant="info">{t('notifications.newBadge')}</Badge> : null}
                </div>
                {n.body ? <p className="text-muted-foreground mt-1 text-sm">{n.body}</p> : null}
                <p className="text-muted-foreground mt-2 text-xs">{formatRelative(n.createdAt)}</p>
              </div>
              {!n.read ? (
                <Button variant="outline" size="sm" onClick={() => markRead.mutate(n.id)}>
                  {t('notifications.markRead')}
                </Button>
              ) : null}
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
}
